<template>
    <div class="m-score">
    <span class="m-score__title">Score</span>
    <span class="m-score__value">{{ getScore }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getScore']),
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/Score.vue